import { triggerGuardedClientReload } from '../services/clientVersion';
import { classifyAssetLoadFailure } from './assetLoadFailure';

let isInstalled = false;

const attemptAssetRecoveryReload = (error: unknown): boolean => {
  const assetLoadFailure = classifyAssetLoadFailure(error);
  if (!assetLoadFailure) {
    return false;
  }

  return triggerGuardedClientReload();
};

export const installAssetLoadFailureRecoveryListeners = (): (() => void) => {
  if (typeof window === 'undefined' || isInstalled) {
    return () => {};
  }

  const onVitePreloadError = (event: Event) => {
    const viteEvent = event as Event & { payload?: unknown };
    attemptAssetRecoveryReload(viteEvent.payload ?? viteEvent);
    // Do not prevent Vite's event: it must rethrow the preload error rather
    // than resolving the dynamic import to undefined before the reload lands.
  };

  const onUnhandledRejection = (event: PromiseRejectionEvent) => {
    if (attemptAssetRecoveryReload(event.reason)) {
      event.preventDefault();
    }
  };

  const onWindowError = (event: ErrorEvent) => {
    if (attemptAssetRecoveryReload(event.error ?? event)) {
      event.preventDefault();
    }
  };

  window.addEventListener('vite:preloadError', onVitePreloadError);
  window.addEventListener('unhandledrejection', onUnhandledRejection);
  window.addEventListener('error', onWindowError);
  isInstalled = true;

  return () => {
    window.removeEventListener('vite:preloadError', onVitePreloadError);
    window.removeEventListener('unhandledrejection', onUnhandledRejection);
    window.removeEventListener('error', onWindowError);
    isInstalled = false;
  };
};
